/**
 * PlacementClosureBadge - the closure chip (§10.6): offen / erledigt + the relevant date (the
 * start while offen, the end once erledigt). Shown as the Kopfbereich extraBadge.
 */

import { Badge } from '../../components/ui/Badge';
import { PLACEMENT_CLOSURE_STATUS_LABELS, PLACEMENT_ABSCHLUSS_ART_LABELS } from '@brokly/shared';
import type { PlacementClosureStatus, PlacementAbschlussArt } from '@brokly/shared';
import { dateShortDe } from '../../lib/format';

export function PlacementClosureBadge({
  status,
  startZeitpunkt,
  endZeitpunkt,
  abschlussArt,
}: {
  status: PlacementClosureStatus;
  startZeitpunkt: string;
  endZeitpunkt: string | null;
  /** P2 Slice 15: tooltips the badge with the Abschluss-Art once erledigt (label text unchanged). */
  abschlussArt?: PlacementAbschlussArt | null;
}) {
  const erledigt = status === 'erledigt';
  const date = erledigt ? endZeitpunkt : startZeitpunkt;
  return (
    <Badge
      variant={erledigt ? 'success' : 'neutral'}
      data-testid="placement-closure-badge"
      {...(abschlussArt ? { title: PLACEMENT_ABSCHLUSS_ART_LABELS[abschlussArt] } : {})}
    >
      {PLACEMENT_CLOSURE_STATUS_LABELS[status]}
      {date ? ` · ${dateShortDe(date)}` : ''}
    </Badge>
  );
}
